import { OrgType, User, UserProfile } from 'api/model'

export function customerOrgProfiles(user: User): UserProfile[] {
  return user.profiles.filter((up) => up.organization.type === OrgType.customer)
}
